<template>
    <div>
        <el-row :gutter="20"
                style="margin-bottom: 20px">
            <el-col :span="16">
                <el-radio-group v-model="filter.status"
                                size="small"
                                v-loading="loading">
                    <!--TODO Language-->
                    <el-radio-button :label="null">{{$t('claims.active')}}</el-radio-button>
                    <el-radio-button :label="1">{{newTotal}} {{$t('common.new')}}</el-radio-button>
                    <el-radio-button :label="3">{{mircTotal}} {{$t('common.moreInformationRequiredClaims')}}</el-radio-button>
                    <el-radio-button :label="7">{{prpcTotal}} {{$t('common.pendingReturnPartClaims')}}</el-radio-button>
                    <!-- <el-radio-button :label="8">{{prccTotal}} Pending Return Code Corrections</el-radio-button> -->
                <el-radio-button v-if="$isFullAdmin"
                                 :label="5">{{modifiedTotal}} {{$t('common.modifiedClaims')}}</el-radio-button>
                <el-radio-button :label="4">{{rejectedTotal}} {{$t('common.rejectedClaims')}}</el-radio-button>
                <el-radio-button :label="0">{{deletedTotal}} {{$t('common.deletedClaims')}}</el-radio-button>
                <el-radio-button :label="6">{{paidTotal}} {{$t('common.paidClaims')}}</el-radio-button>
                <el-radio-button :label="10">{{techReviewTotal}} {{$t('common.pendingTechnicalReviewClaims')}}</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="1.8">
                <el-button :loading="exporting"
                           icon="el-icon-download"
                           @click="download">{{$t('common.export')}}</el-button>
            </el-col>

            <el-col :span="3" style="width:auto;">
                <el-input v-model="filter.RaisedBy"
                          :placeholder="$t('common.raisedBy')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>

            <el-col :span="4" style="width:auto;">
                <el-input v-model="filter.text"
                          :placeholder="$t('common.searchAllClaims')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>

        </el-row>
            <el-row style="display: flex; justify-content: flex-end; margin-right: 35px; margin-bottom: 20px;">
                <el-col :span="3" style="width:auto;">
                    <el-date-picker v-model="filter.dateFrom"
                                    type="date"
                                    :placeholder="placeHolderDateFrom"
                                    style="width:100%;"></el-date-picker>
                </el-col>
                <el-col :span="3" style="width:auto;">
                    <el-date-picker v-model="filter.dateTo"
                                    type="date"
                                    :placeholder="placeHolderDateTo"
                                    style="width:100%;"></el-date-picker>
                </el-col>
            </el-row>
            <el-table size="mini"
                      :data="claims"
                      v-loading="loading"
                      class="claims-table tablewithshading"
                      @sort-change="sortClaims">
                <el-table-column prop="claimNumber"
                                 :label="$t('common.claimNumber')" sortable="custom"></el-table-column>
                <el-table-column prop="invoiceNumber"
                                 :label="$t('common.invoiceNumber')" sortable="custom"></el-table-column>
                <el-table-column :label="$t('common.total')" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.total | money }}
                    </template>
                </el-table-column>
                <el-table-column v-if="$isFullAdmin"
                                 prop="status"
                                 :label="$t('common.status')"
                                 sortable="custom">
                    <template slot-scope="scope">
                        <el-select v-if="$i18n.locale == 'en'" v-on:change="handleStatusChange(scope.row.id, scope.row.status)"
                                   v-model="scope.row.status">
                            <el-option :label="$t('common.new')"
                                       value="1"></el-option>
                            <el-option :label="$t('common.acceptAndProcess')"
                                       value="2"></el-option>
                            <el-option :label="$t('common.moreinfoRequired')"
                                       value="3"></el-option>
                            <el-option :label="$t('common.rejected')"
                                       value="4"></el-option>
                            <el-option :label="$t('common.paid')"
                                       value="6"></el-option>
                            <el-option :label="$t('common.pendingReturnPart')"
                                       value="7"></el-option>
                            <el-option :label="$t('common.pendingRepairCodeCorrections')"
                                       value="8"></el-option>
                            <el-option :label="$t('common.correctedRepairCodes')"
                                       value="9"></el-option>
                            <el-option :label="$t('common.pendingTechnicalReview')"
                                       value="10"></el-option>
                        </el-select>
                        <el-select v-else v-on:change="handleStatusChange(scope.row.id, scope.row.statusFr)"
                                   v-model="scope.row.statusFr">
                            <el-option :label="$t('common.new')"
                                       value="1"></el-option>
                            <el-option :label="$t('common.acceptAndProcess')"
                                       value="2"></el-option>
                            <el-option :label="$t('common.moreinfoRequired')"
                                       value="3"></el-option>
                            <el-option :label="$t('common.rejected')"
                                       value="4"></el-option>
                            <el-option :label="$t('common.paid')"
                                       value="6"></el-option>
                            <el-option :label="$t('common.pendingReturnPart')"
                                       value="7"></el-option>
                            <el-option :label="$t('common.pendingRepairCodeCorrections')"
                                       value="8"></el-option>
                            <el-option :label="$t('common.correctedRepairCodes')"
                                       value="9"></el-option>
                            <el-option :label="$t('common.pendingTechnicalReview')"
                                       value="10"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column v-else
                                 prop="status"
                                 :label="$t('common.status')"
                                 sortable="custom"></el-table-column>
                <el-table-column prop="raisedBy"
                                 :label="$t('common.raisedBy')" sortable="custom"></el-table-column>
                <el-table-column prop="Raised On" :label="$t('reports.createdOn')" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.raisedOn | date }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('claims.daysCompletion')" sortable="custom">
                    <template slot-scope="scope">
                        <div v-bind:class="{ 'red-bolded': scope.row.daysCompletion > 30, 'green-bolded': scope.row.daysCompletion <= 30 }">{{ scope.row.daysCompletion }}</div>
                    </template>
                </el-table-column>
                <el-table-column v-if="this.statusForShowingDates == 6" :label="$t('common.acceptedDate')" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.acceptedDate | date }}
                    </template>
                </el-table-column>
                <el-table-column v-if="this.statusForShowingDates == 3 || this.statusForShowingDates == 7" :label="$t('claims.commentDate')" sortable="custom">
                    <template slot-scope="scope">
                        {{ showDateOfComment(scope.row) | date }}
                    </template>
                </el-table-column>
                <el-table-column v-if="this.statusForShowingDates == 5" :label="$t('claims.modifiedDate')" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.modifiedDate | date }}
                    </template>
                </el-table-column>
                <el-table-column v-if="this.statusForShowingDates == 4" :label="$t('claims.rejectedDate')" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.rejectedDate | date }}
                    </template>
                </el-table-column>
                <el-table-column v-if="this.statusForShowingDates == 0" :label="$t('claims.deletedDate')" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.deletedDate | date }}
                    </template>
                </el-table-column>
                <el-table-column v-if="this.statusForShowingDates == 10" :label="$t('claims.assignedDate')" sortable="custom">
                    <template slot-scope="scope" >
                        {{scope.row.assignedDate | date }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('common.serviceTicketNumber')" prop="serviceTicketId" sortable="custom">
                    <template slot-scope="scope" >
                        {{scope.row.serviceTicketId }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('common.operations')"
                                 fixed="right"
                                 width="180">
                    <template slot-scope="scope">
                        <el-button size="mini"
                                   @click="viewClaim(scope.row.id)">
                            <i class="el-icon-view"></i>
                        </el-button>
                        <el-button size="mini"
                                   @click="viewClaim(scope.row.id)"
                                   v-if="scope.row.status == 'Partial' || scope.row.status == 'MoreInformationRequired' || $isFullAdmin">
                            <i class="el-icon-edit"></i>
                        </el-button>
                        <el-button size="mini"
                                   type="danger"
                                   @click="deleteClaim(scope.row.id)"
                                   v-if="$isFullAdmin || ($isUser && scope.row.status == 'Partial')">
                            <i class="el-icon-delete"></i>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination class="pager"
                           v-if="total !== 0"
                           @current-change="handleCurrentChange"
                           :current-page.sync="currentPage"
                           :page-size="15"
                           layout="total, prev, pager, next"
                           :total="total">
            </el-pagination>

            <create-update-claim-dialog :claimId="claimToEdit"
                                        :visible="updateClaimVisible"
                                        @dialogClosed="updateClaimFinished"
                                        @previewClaim="viewClaim"
                                        @showClaimPreview="showClaimPreview"
                                        @showClaimConfirm="showClaimConfirm"></create-update-claim-dialog>
            <preview-claim-dialog :claimId="claimToView"
                                  :visible="previewClaimVisible"
                                  :isForPartial="isForPartial"
                                  @dialogClosed="previewClaimFinished"
                                  @editClaim="editClaim"
                                  @claimPublished="claimPublished"
                                  @statusChanged="statusChanged"></preview-claim-dialog>
</div>
</template>

<script>
    import api from "../api";
    import CreateUpdateClaimDialog from "./CreateUpdateClaimDialog";
    import PreviewClaimDialog from "./PreviewClaimDialog";
    import { EventBus } from "@/app/event-bus.js";

    export default {
        name: "claim-list",
        components: {
            CreateUpdateClaimDialog,
            PreviewClaimDialog
        },
        data(vm) {
            return {
                loading: false,
                loadingComments: false,
                isForPartial: false,
                claims: [],
                claimToView: undefined,
                claimToEdit: undefined,
                updateClaimVisible: false,
                previewClaimVisible: false,
                filter: {
                    q: "",
                    status: this.$route.params.status || null
                },
                sorting: {},
                currentPage: 1,
                total: 0,
                placeholder: vm.$t('common.searchAllClaims'),
                placeHolderDateFrom: "",
                placeHolderDateTo: "",
                statusForShowingDates: "-1",
                newTotal: null,
                mircTotal: null,
                prpcTotal: null,
                prccTotal: null,
                modifiedTotal: null,
                rejectedTotal: null,
                deletedTotal: null,
                paidTotal: null,
                techReviewTotal: null,
                exporting: false,
                claimIdComments: undefined
            };
        },
        watch: {
            filter: {
                deep: true,
                handler: function (data) {
                    switch (this.filter.status) {
                        case null:
                            this.placeholder = this.$t('common.searchAllClaims')
                            break;
                        case 1:
                            this.placeholder = this.$t('common.searchInNewClaims')
                            this.placeHolderDateFrom = this.$t('common.fromCreatedDate');
                            this.placeHolderDateTo = this.$t('common.toCreatedDate');
                            this.statusForShowingDates = 1;
                            break;
                        case 3:
                            this.placeholder = this.$t('common.searchInMoreInformationRequiredClaims')
                            this.placeHolderDateFrom = this.$t('common.fromCommentDate');
                            this.placeHolderDateTo = this.$t('common.toCommentDate');
                            this.statusForShowingDates = 3;
                            break;
                        case 7:
                            this.placeholder = this.$t('common.searchInPendingReturnPartClaims')
                            this.placeHolderDateFrom = this.$t('common.fromCommentDate');
                            this.placeHolderDateTo = this.$t('common.toCommentDate');
                            this.statusForShowingDates = 7;
                            break;
                        case 8:
                            this.placeholder = this.$t('common.searchInPendingReturnCodeCorrectionsClaims')
                            this.placeHolderDateFrom = "";
                            this.placeHolderDateTo = "";
                            this.statusForShowingDates = 8;
                            break;
                        case 5:
                            this.placeholder = this.$t('common.searchInModifiedClaims')
                            this.placeHolderDateFrom = this.$t('common.fromModifiedDate');
                            this.placeHolderDateTo = this.$t('common.toModifiedDate');
                            this.statusForShowingDates = 5;
                            break;
                        case 4:
                            this.placeholder = this.$t('common.searchInRejectedClaims')
                            this.placeHolderDateFrom = this.$t('common.fromRejectedDate');
                            this.placeHolderDateTo = this.$t('common.toRejectedDate');
                            this.statusForShowingDates = 4;
                            break;
                        case 0:
                            this.placeholder = this.$t('common.searchInDeletedClaims')
                            this.placeHolderDateFrom = this.$t('common.fromDeletedDate');
                            this.placeHolderDateTo = this.$t('common.toDeletedDate');
                            this.statusForShowingDates = 0;
                            break;
                        case 6:
                            this.placeholder = this.$t('common.searchInPaidClaims')
                            this.placeHolderDateFrom = this.$t('common.fromPaidDate');
                            this.placeHolderDateTo = this.$t('common.toPaidDate');
                            this.statusForShowingDates = 6;
                            break;
                        case 10:
                            this.placeholder = this.$t('common.searchInPendingTechReviewClaims');
                            this.placeHolderDateFrom = this.$t('common.fromAssignedDate');
                            this.placeHolderDateTo = this.$t('common.toAssignedDate');
                            this.statusForShowingDates = 10;
                            break;
                        case 11:
                            this.placeholder = this.$t('common.searchInPendingTechReviewClaims');
                            break;
                    }

                    if (this.filter.status === null && this.$route.params.status != null) {
                        window.location.href = "/#/claims";
                    }
                    this.loadClaims();
                    this.loadCategories();
                }
            }
        },
        created() {
            this.loadClaims();
            this.loadCategories();
        },
        mounted() {
            var self = this;
            EventBus.$on("claim-created", () => {
                this.loadCategories();
                this.loadClaims();
            });
            EventBus.$on("showClaimConfirm", claimId => {
                this.showClaimConfirm(claimId);
            });
        },
        beforeDestroy() {
            EventBus.$off("claim-created");
            EventBus.$off("showClaimConfirm");
        },
        methods: {
            loadClaims() {
                this.loading = true;
                api.getClaims(this.currentPage, this.filter, this.sorting).then(response => {
                    this.loading = false;
                    this.claims = response.data.items;
                    this.total = response.data.total;
                });
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadClaims();
            },
            viewClaim(id) {
                this.claimToView = id;
                this.previewClaimVisible = true;
            },
            showClaimConfirm(id) {
                this.claimToView = id;
                this.isForPartial = true;
                this.previewClaimVisible = true;
            },
            editClaim(id) {
                this.claimToEdit = id;
                this.updateClaimVisible = true;
            },
            deleteClaim(id) {
                this.$confirm(this.$t('common.thisWillDeleteClaimContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteClaim(id).then(() => {
                            this.loadClaims();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => { });
            },
            download() {
                this.exporting = true;
                if (!this.filter.dateFrom && !this.filter.dateTo) {
                    var dateToday = new Date();
                    var day = dateToday.getDate();
                    var month = Number(dateToday.getMonth() + 1);
                    var year = Number(dateToday.getFullYear());
                    this.$confirm(
                        this.$t('common.theExportWillBeGeneratedForAPeriodOfOneYear') + (year - 1) + '/' + month + '/' + day + " - " + year + '/' + month + '/' + day + this.$t('common.sinceTheDateRangeWasNotSelectedPleaseConfirm'),
                        "Warning",
                        {
                            confirmButtonText: this.$t('common.OK'),
                            cancelButtonText: this.$t('common.cancel'),
                            type: "warning"
                        }
                    )
                        .then(() => {
                            api.exportView(this.currentPage, this.filter, this.sorting).then(() => {
                                this.exporting = false;
                                this.$message({
                                    title: this.$t('common.success'),
                                    message: this.$t('common.exportWasGeneratedSuccesfully'),
                                    type: "success"
                                });
                            });
                        }).catch(_ => {this.exporting = false; });

                }
                else {
                    api.exportView(this.currentPage, this.filter, this.sorting).then(() => {
                        this.exporting = false;
                        this.$message({
                            title: this.$t('common.success'),
                            message: this.$t('common.exportWasGeneratedSuccesfully'),
                            type: "success"
                        });
                    });
                }
            },
            sortClaims(sort) {
                let sortBy = sort.prop;
                if (!sortBy && sort.column != null) {
                    sortBy = sort.column.label;
                }
                let sortOrder = sort.order;
                this.sorting = {
                    sortBy,
                    sortOrder
                };
                if (this.currentPage === 1) {
                    this.loadClaims();
                } else {
                    this.currentPage = 1;
                }
            },
            loadCategories() {
                this.loading = true;
                api.getCategories().then(response => {
                    this.loading = false;
                    this.newTotal = response.data.find(x => x.status === 1).total;
                    this.mircTotal = response.data.find(x => x.status === 3).total;
                    this.prpcTotal = response.data.find(x => x.status === 7).total;
                    this.prccTotal = response.data.find(x => x.status === 8).total;
                    this.modifiedTotal = response.data.find(x => x.status === 5).total;
                    this.rejectedTotal = response.data.find(x => x.status === 4).total;
                    this.deletedTotal = response.data.find(x => x.status === 0).total;
                    this.paidTotal = response.data.find(x => x.status === 6).total;
                    this.techReviewTotal = response.data.find(x => x.status === 10).total + (response.data.find(x => x.status === 11)||{total:0}).total;
                });
            },
            updateClaimFinished() {
                this.claimToEdit = undefined;
                this.updateClaimVisible = false;
            },
            previewClaimFinished() {
                this.isForPartial = false;
                this.claimToView = undefined;
                this.previewClaimVisible = false;
            },
            showClaimPreview(id) {
                this.claimToView = id;
                this.previewClaimVisible = true;
            },
            claimPublished() {
                this.$notify({
                    title: this.$t('common.success'),
                    message: this.$t('common.claimWasSubmittedSuccesfully'),
                    type: "success"
                });
                this.loadCategories();
                this.loadClaims();
            },
            handleStatusChange(id, newStatus) {
                this.claims.status = newStatus;
                this.claims.statusFr = newStatus;
                this.$confirm(
                    this.$t('common.areYouSureYouWantToChangeStatusOfClaim'),
                    "Warning",
                    {
                        confirmButtonText: this.$t('common.OK'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: "warning"
                    }
                )
                    .then(() => {
                        api.changeStatusOfClaim(id, newStatus).then(() => {
                            if (newStatus === 6) {
                                this.$notify({
                                    title: this.$t('common.success'),
                                    message: this.$t('common.claimStatusWasUpdatedSuccesfully'),
                                    type: "success"
                                });
                            }
                            if (newStatus == 10 || newStatus == 11) {
                                api.sendEmailToReviewer(id, newStatus);
                                this.$notify({
                                    title: this.$t('common.success'),
                                    message: this.$t('common.claimStatusWasUpdatedSuccesfully'),
                                    type: "success"
                                });
                            }
                            this.loadClaims();
                        });
                    })
                    .catch(_ => { });
            },
            //showCommentsDialog(claimId) {
            //    this.claimIdComments = claimId;
            //    api.loadComments(claimId).then(response => {
            //        this.comments = response.data;
            //        this.commentShowDialog = true;
            //    });
            //},
            //postComment() {
            //    this.$refs["commentForm"].validate(valid => {
            //        if (valid) {
            //            // if (typeof this.commentForm.status != "undefined") {
            //            //   this.$confirm(
            //            //     "Are you sure you want to change status of claim?",
            //            //     "Warning",
            //            //     {
            //            //       confirmButtonText: this.$t('common.OK'),
            //            //       cancelButtonText: this.$t('common.cancel'),
            //            //       type: "warning"
            //            //     }
            //            //   )
            //            //     .then(() => {
            //            this.loadingComments = true;
            //            api
            //                .submitComment(this.claimIdComments, this.commentForm)
            //                .then(response => {
            //                    this.$refs["commentForm"].resetFields();
            //                    this.comments.push(response.data);
            //                    this.loadingComments = false;
            //                });
            //            // })
            //            // .catch(_ => {});
            //            // } else {
            //            // this.loadingComments = true;
            //            // api
            //            //   .submitComment(this.claimIdComments, this.commentForm)
            //            //   .then(response => {
            //            //     this.$refs["commentForm"].resetFields();
            //            //     this.comments.push(response.data);
            //            //     this.loadingComments = false;
            //            //   });
            //            // }
            //        } else {
            //            return false;
            //        }
            //    });
            //},
            //closeDialog() {
            //    this.commentShowDialog = false;
            //    this.claimIdComments = null;
            //    this.comments = [];
            //    this.loadClaims();
            //},
            statusChanged() {
                this.loadClaims();
            },
            showDateOfComment(commentObject) {
                if (!commentObject.comments.length) {
                    return "";
                }

                return commentObject.comments[commentObject.comments.length - 1].on;
            }
        }
    };
</script>
<style scoped>
    .comment-box {
        list-style: none;
        padding: 0;
        margin-top: 0;
        max-height: 400px;
    }

        .comment-box > > > li {
            margin-bottom: 10px;
        }

        .comment-box > > > p {
            margin-bottom: 0;
            margin-top: 0;
        }

    .red-bolded {
        color: red;
        font-weight: bold;
    }

    .green-bolded {
        color: green;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/claims/components/ClaimList.vue